require('./hostnameMatchService');

'use strict';

angular.module('app.appKey', [
  'app.hostnameMatchService'
])
  .factory('appKey', [
    '$cookies', 'hostnameMatchService',
    function ($cookies, hostnameMatch) {
      let app_id;

      app_id = $cookies.get('appKey.app_id');

      if (!app_id) {
        app_id = Math.floor((Math.random() * 100000) + 1) + '.' + moment().unix();
        $cookies.put('appKey.app_id', app_id, { domain: hostnameMatch.domain(), samesite: 'None', secure: true });
      }

      let appKey = {
        app_key: 'e17e46c337854e54984a7f014bfcb7dd',
        app_id: app_id,
        user_key: null,
        set_user_key: function (key) {
          appKey.user_key = key;
          return $cookies.put('appKey.user_key', key, { domain: hostnameMatch.domain(), samesite: 'None', secure: true });
        },
        set_user_key_from_cookie: function () {
          return appKey.user_key = $cookies.get('appKey.user_key');
        },
        destroy: function () {
          appKey.user_key = null;
          return $cookies.remove('appKey.user_key', { domain: hostnameMatch.domain() });
        }
      };

      return appKey;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/appKey.js